module.exports = function () {
	const btn = document.getElementById('group-header-button');
	const el = document.getElementsByClassName('products-page-wrapper');

	if (!btn) return;

	btn.addEventListener('click', function(e) {
		e.preventDefault();
		el[0].scrollIntoView({block: 'start', behavior: 'smooth', offsetTop: 200,});
	});
};
